var _a;
import { FontStroke } from "@lib/titan2/dist/game/control/properties/FontProperties";
/**
 * The paytable has a different font style for each layer
 */
export class GamePaytableFonts {
    constructor() { }
    static getFontForExceeded(patterns, shadowMultiplier) {
        return {
            colour: this.EXCEEDED_COLOURS[patterns],
            stroke: new FontStroke(this.EXCEEDED_STROKES[patterns], shadowMultiplier * this.TARGET_STROKE_THICKNESS),
        };
    }
    static getFontForUnreached(patterns, shadowMultiplier) {
        return {
            colour: this.UNREACHED_COLOURS[patterns],
            stroke: new FontStroke(this.UNREACHED_STROKES[patterns], shadowMultiplier * this.TARGET_STROKE_THICKNESS),
        };
    }
    static getFontForHighlighted(patterns, shadowMultiplier) {
        return {
            colour: this.HIGHLIGHTED_COLOURS[patterns],
            stroke: new FontStroke(this.HIGHLIGHTED_STROKES[patterns], shadowMultiplier * this.TARGET_STROKE_THICKNESS),
        };
    }
    static getFontForAvailableWin(patterns, shadowMultiplier) {
        return {
            colour: this.AVAILABLE_WIN_COLOURS[patterns],
            stroke: new FontStroke(this.AVAILABLE_WIN_STROKES[patterns], shadowMultiplier * this.TARGET_STROKE_THICKNESS),
        };
    }
}
_a = GamePaytableFonts;
GamePaytableFonts.TARGET_STROKE_THICKNESS = 10;
GamePaytableFonts.EXCEEDED_COLOURS = [
    "#03032e", //1
    "#03032e", //2
    "#03032e", //3
    "#03032e", //4
    "#03032e", //5
    "#03032e", //6
    "#03032e", //7
    "#03032e", //8
    "#03032e", //9
    "#03032e", //10
    "#03032e", //FH
];
GamePaytableFonts.UNREACHED_COLOURS = [
    "#f0fbfd", //1
    "#f0fbfd", //2
    "#f0fbfd", //3
    "#f0fbfd", //4
    "#f0fbfd", //5
    "#f0fbfd", //6
    "#f0fbfd", //7
    "#f0fbfd", //8
    "#f0fbfd", //9
    "#f0fbfd", //10
    "#f0fbfd", //FH
];
GamePaytableFonts.HIGHLIGHTED_COLOURS = _a.UNREACHED_COLOURS;
GamePaytableFonts.AVAILABLE_WIN_COLOURS = _a.UNREACHED_COLOURS;
GamePaytableFonts.EXCEEDED_STROKES = [
    "#00000000", //1
    "#00000000", //2
    "#00000000", //3
    "#00000000", //4
    "#00000000", //5
    "#00000000", //6
    "#00000000", //7
    "#00000000", //8
    "#00000000", //9
    "#00000000", //10
    "#00000000", //FH
];
GamePaytableFonts.UNREACHED_STROKES = [
    "#74179e", //1
    "#74179e", //2
    "#511ca2", //3
    "#511ca2", //4
    "#2f3c9c", //5
    "#1e5b8a", //6
    "#096569", //7
    "#066e50", //8
    "#4c8327", //9
    "#737e1a", //10
    "#88540a", //FH
];
GamePaytableFonts.HIGHLIGHTED_STROKES = _a.UNREACHED_STROKES;
GamePaytableFonts.AVAILABLE_WIN_STROKES = _a.UNREACHED_STROKES;
//# sourceMappingURL=GamePaytableFonts.js.map